import { Group, Select } from '@byecode/ui'
import type { ScheduledTriggerConfig, ScheduledTriggerRule } from '@lighthouse/shared'
import { ListItem4ByecodeUi } from '@lighthouse/shared'
import React from 'react'

import * as SC from '../../styles'
import { CommonRuleSettingUnit } from './CommonRuleSettingUnit'

interface CommonRuleProps {
    value: ScheduledTriggerConfig
    onChange: (value: ScheduledTriggerConfig) => void
}

export const rulesOptions: { label: string; value: ScheduledTriggerRule }[] = [
    { label: '只触发一次', value: 'ONCE' },
    { label: '按分钟', value: 'MINUTE' },
    { label: '按小时', value: 'HOUR' },
    { label: '按天', value: 'DAY' },
    { label: '按工作日', value: 'WEEKDAY' },
    { label: '每周', value: 'WEEK' },
    { label: '每月', value: 'MONTH' }
]

export const CommonRule: React.FC<CommonRuleProps> = ({ value, onChange }) => {
    const scheduleRule: ScheduledTriggerRule = value?.scheduleRule ?? 'ONCE'

    return (
        <Group label="重复规则">
            <ListItem4ByecodeUi>
                <SC.FormItemLabelWrapper>
                    <SC.FormItemLabel>规则</SC.FormItemLabel>
                </SC.FormItemLabelWrapper>
                <SC.FormItemContent>
                    <Select
                        value={scheduleRule}
                        options={rulesOptions}
                        onChange={val => onChange({ ...value, scheduleRule: val as ScheduledTriggerRule })}
                    />
                </SC.FormItemContent>
            </ListItem4ByecodeUi>
            <CommonRuleSettingUnit scheduleRule={scheduleRule} value={value} onChange={onChange} />
        </Group>
    )
}
